import { Maybe } from '../common-types/types';

export const logJsonObj = <T = any>(object: Maybe<T>, message: Maybe<string> = `Log me this value ==>`) => {
  const value = JSON.stringify(object, null, 2);
  console.log(`🚀 ~ ${message}`, value);
};
